import { useCallback, useEffect, useRef } from 'react';

export const useOnClickOutside = (onClickOutside: () => void, otherRef?: React.RefObject<HTMLElement | null>) => {
  const wrapperRef = useRef<HTMLDivElement>(null);

  const handleClose = useCallback(
    (event: MouseEvent) => {
      if (
        wrapperRef.current &&
        !wrapperRef.current.contains(event.target as Node) &&
        !otherRef?.current?.contains(event.target as Node)
      ) {
        onClickOutside();
      }
    },
    [onClickOutside, otherRef],
  );

  useEffect(() => {
    document.addEventListener('mousedown', handleClose);

    return () => document.removeEventListener('mousedown', handleClose);
  }, [handleClose]);

  return wrapperRef;
};
